export default __webpack_public_path__ + "static/aboutCompany3-52225ea8096f3633ba070ace4049e2ed.png";